import { i18n } from "@lingui/core";

export type SupportedLocale = "en-US" | "ko-KR" | "ja-JP";

export const DEFAULT_LOCALE: SupportedLocale = "en-US";

const SUPPORTED_LOCALES: SupportedLocale[] = ["en-US", "ko-KR", "ja-JP"];

export function detectLocale(configLocale?: string): SupportedLocale {
  // Config default locale (fallback)
  const defaultLocale =
    configLocale && isValidLocale(configLocale)
      ? (configLocale as SupportedLocale)
      : DEFAULT_LOCALE;

  // Priority 1: Check URL parameter (highest priority)
  // Require exact match: "en-US", "ko-KR", or "ja-JP"
  if (typeof window !== "undefined") {
    const urlParams = new URLSearchParams(window.location.search);
    const urlLocale = urlParams.get("locale");
    if (urlLocale && isValidLocale(urlLocale)) {
      return urlLocale as SupportedLocale;
    }

    // Priority 2: Check localStorage for saved preference
    const savedLocale = localStorage.getItem("widget-locale");
    if (savedLocale && isValidLocale(savedLocale)) {
      return savedLocale as SupportedLocale;
    }

    // Priority 3: Check browser language as a hint
    const browserLang = navigator.language;
    if (browserLang.toLowerCase().startsWith("ko")) {
      return "ko-KR";
    }
    if (browserLang.toLowerCase().startsWith("ja")) {
      return "ja-JP";
    }
  }

  // Priority 4: Return config default or fallback to English
  return defaultLocale;
}

// Helper function to validate locale
function isValidLocale(locale: string): boolean {
  return SUPPORTED_LOCALES.includes(locale as SupportedLocale);
}

export async function activateLocale(locale: SupportedLocale) {
  // Messages are already loaded in init.ts, just activate the locale
  i18n.activate(locale);
  localStorage.setItem("widget-locale", locale);
}
